export type PodStatus = "nominal" | "warning" | "fault" | "offline";

export interface SensorReading {
  label: string;
  value: number;
  unit: string;
  status: PodStatus;
}

export interface BioPod {
  id: string;
  name: string;
  site: string;
  tenant: string;
  status: PodStatus;
  sensors: SensorReading[];
  /** ISO 8601. */
  lastUpdate: string;
}

/** How each status is written in the interface. */
export const STATUS_LABEL: Record<PodStatus, string> = {
  nominal: "Normal",
  warning: "Warning",
  fault: "Fault",
  offline: "Offline",
};
